// Tango ADB Entry Point - 整合所有需要的模块
import * as Adb from '@yume-chan/adb';
import * as AdbDaemonWebUsb from '@yume-chan/adb-daemon-webusb';
import * as AdbCredentialWeb from '@yume-chan/adb-credential-web';
import * as StreamExtra from '@yume-chan/stream-extra';

// 导出所有模块
window.TangoADB = {
  Adb,
  AdbDaemonWebUsb,
  AdbCredentialWeb,
  StreamExtra
};

console.log('Tango ADB loaded:', Object.keys(window.TangoADB));
